<template>
  <div id="StockCalender">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{deviceName}}在庫状況（{{updateTime}} 時点）</p>
      </header>
      <section class="modal-card-body">
        <table>
          <tr>
            <td colspan="2">
              <vc-calendar
                is-expanded
                style="width:100%; height: 100%;"
                :first-day-of-week="2"
                @update:from-page="changePage"
              >
                <template slot="header-title" slot-scope="page">{{page.yearLabel}}年{{page.monthLabel}}</template>
                <template slot="day-content" slot-scope="props">
                  <section :set="dayType = getDayType(props.day)">
                  <section :set="zaikoType = getZaikoType(props.day)">
                    <div :class="getNotShippingDayClass(dayType.canShippingDay)" class="vc-border" is-expanded>
                      <div style="border: 1px solid #ccc; text-align:center">
                        <div :class="dayType.type" style="border: 1px solid #ccc;">{{ props.day.day }}</div>
                        <template v-if="dayType.canShippingDay && zaikoType == -1">
                          <div class="dayContents">
                            <div :class="'iconArea ' + addZaikoIcon(zaikoType)" />
                            <div style="text-align:center;">在庫 {{getZaiko(props.day.day)}}台</div>
                          </div>
                        </template>
                        <template v-else-if="dayType.canShippingDay">
                          <div class="dayContents canClick" v-on:click="selectDay(props.day)">
                            <div :class="'iconArea ' + addZaikoIcon(zaikoType)" />
                            <div style="text-align:center;">在庫 {{getZaiko(props.day.day)}}台</div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="dayContents">
                          </div>
                        </template>
                      </div>
                    </div>
                  </section>
                  </section>
                </template>
              </vc-calendar>
            </td>
          </tr>
        </table>
      </section>
      <footer class="modal-card-foot">
      </footer>
    </div>
  </div>
</template>
<script>
const holiday_jp = require("@holiday-jp/holiday_jp");
const philipsHolidays = require('@/components/mock/base/philipsHollday.json')
export default {
  name: "StockCalender",
  props: {
    deviceKind: {},
    count: {},
    receptionNo: ""
  },
  methods: {
    changePage: function(event) {
      //祝日を更新する
      var sDate = new Date(event.year, event.month -1, 1)
      var eDate = new Date(event.year, event.month, 0)
      this.holidays = holiday_jp.between(sDate,eDate);
      //↓該当月の内容を更新する
      this.chengeList(event);
    },
    chengeList:function (event) {
      let _this = this;
      let body = {
              modelValue: this.deviceKind,
              year: event.year,
              month: event.month,
              receptionNo: this.receptionNo
      };
      this.apiCall(
        function(client){
          return client.apis.internalKenshin.getKenshinkawagoeDeviceStockPOST({
            body:body
          });
        },
        function(result){
          let ret = result.obj;
          _this.deviceName = ret.modelName;
          _this.updateTime = ret.updateTime;
          _this.list = ret.stockList;
        },
        function(error){
          _this.showErrorMessage(error)
        }
      );
    },
    getDayType: function(day){
      var canShippingDay = day.date >= this.today;
      if (day.weekday == 1 || day.weekday == 7) {
        return {
          type:"holiday",
          canShippingDay: false
        };
      }
      for (var i in this.holidays) {
        if (this.yyyy_hyp_MM_hyp_dd(day.date) == this.yyyy_hyp_MM_hyp_dd(this.holidays[i].date)) {
          return {
            type:"holiday",
            canShippingDay: false
          };
        }
      }
      //PHILIPS特別休日
      if(philipsHolidays.irregular.includes(this.yyyy_hyp_MM_hyp_dd(day.date))){
          return {
            type:"holiday",
            canShippingDay: false
          };
      }
      //年末年始
      if(philipsHolidays.everyyear.includes(this.MM_hyp_dd(day.date))){
          return {
            type:"holiday",
            canShippingDay: false
          };
      }
      if(this.yyyy_hyp_MM_hyp_dd(day.date) == this.yyyy_hyp_MM_hyp_dd(new Date())){
        return {
          type:"today",
          canShippingDay: canShippingDay
        };
      }
      return {
        type:"weekday",
        canShippingDay: canShippingDay
      };
    },
    getNotShippingDayClass: function(canShippingDay){
      if(!canShippingDay){
        return "notShippingDay";
      } else {
        return ""
      }
    },
    getContents: function(day) {
        return this.list[day];
    },
    getZaikoType: function(day){
      if(this.list.length > 0 ){
        if(this.list[day.day].stockCount- this.count < 0){
          //引当後の在庫がマイナス
          return -1
        } else if(this.list[day.day].stockCount- this.count < this.count /2 ){
          //引当後の在庫数が被験者数の2分の1より少なくなる
          return 0
        } else if(this.list[day.day].stockCount- this.count < this.count){
          //引当後の在庫数が被験者数より少なくなる
          return 1
        } else {
          //引当後の在庫数が被験者数以上残っている
          return 2
        }
      }
    },
    addZaikoIcon: function(zaikoType){
      //在庫が不足している
      if(zaikoType == -1){
        return "mdi mdi-close mdi-48px"
      } else if(zaikoType == 0 ){
        return "mdi mdi-triangle-outline mdi-48px"
      } else if(zaikoType == 1){
        return "mdi mdi-circle-outline mdi-48px"
      } else {
        return "mdi mdi-circle-double mdi-48px"
      }
    },
    getZaiko: function(day){
      return this.list.length > 0 ? this.list[day].stockCount: 0;
    },
    selectDay: function(day){
      this.$emit('select', day.date);
    },
  },
  data() {
    var today = new Date()
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    return {
      holidays: [],
      deviceName: "",
      updateTime: "",
      list:[],
      today: today
    };
  },
  filters: {},
  components: {},
  mounted: function () {
    this.chengeList({
      year: this.today.getFullYear(),
      month: this.today.getMonth() +1
    })
  },
};
</script>
<style lang="scss" scoped>
.dayContents {
  min-height:80px; 
  position: relative;
}
.iconArea {
  width:48px;
  height:60px;
  margin: 0 auto;
}
.notShippingDay {
   height:100%;
   background-color: lightgrey;
}
.holiday {
  background-color: #ffbbff;
  color: red;
}
.today {
  background-color: blue;
  color: white;
}
.canClick {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/stock/StockCalender.vue